import { createStore } from 'vuex'
import service from '@/utils/request'
export default createStore({
  state: {
    //配置  对象 { a: '2',b"2}
    config: null,
    //权限  数组 [1,2,3]
    permit: null,
    excel: ['xls', 'xlsx'],
    pdf: ['pdf'],
    pic: ['jpg', 'gif', 'svg', 'jpeg', 'bmp', 'png'],
    ppt: ['ppt', 'pptx'],
    txt: ['txt'],
    word: ['doc', 'docx'],
    yasuo: ['zip', 'rar'],
    radio: ['mp3', 'aac', 'm4a', 'ape', 'flac', 'wav', 'wma', 'amr', 'midi'],
    video: ['mp4', 'mv4', 'mpg', 'flv', 'f4v', 'swf', 'wmv', 'mov', 'mts', 'm2t', 'webm', 'ogg', 'mkv'],
    // 侧边菜单
    menuSideList: []
  },
  getters: {
    menuSideList(state) {
      return state.menuSideList
    }
  },
  mutations: {
    getConfig(state, val) {
      state.config = val
    },
    getPermi(state, val) {
      state.permit = val
    },
    setMenuSideList(state, val) {
      state.menuSideList = val
    }
  },
  actions: {
    async getConfigAsync(context, ptCode) {
      // let params = {
      //   ptCode: ptCode
      // }
      let res = await service({
        url: '/api/menu/getConfig',
        method: 'get',
        // params: params
      })
      if (!res.code && res.state === 200) {
        context.commit('getConfig', res.data)
      }
    },
    async getPermiAsync(context) {
      let res = await service({
        url: '/api/system/getPermissionList',
        method: 'get',
      })
      if (!res.code && res.state === 200) {
        context.commit('getPermi', res.data)
      }
    },
  },
  modules: {
  }
})
